__turbopack_context__.v({
  "button_sec": "IllusionMuseum-module-scss-module__jb6FTG__button_sec",
  "card": "IllusionMuseum-module-scss-module__jb6FTG__card",
  "content_div": "IllusionMuseum-module-scss-module__jb6FTG__content_div",
  "content_sec": "IllusionMuseum-module-scss-module__jb6FTG__content_sec",
  "experience_sec": "IllusionMuseum-module-scss-module__jb6FTG__experience_sec",
  "faqs_heading_sec": "IllusionMuseum-module-scss-module__jb6FTG__faqs_heading_sec",
  "flex_row": "IllusionMuseum-module-scss-module__jb6FTG__flex_row",
  "flex_row_data_sec": "IllusionMuseum-module-scss-module__jb6FTG__flex_row_data_sec",
  "gradient_sec": "IllusionMuseum-module-scss-module__jb6FTG__gradient_sec",
  "headings_sec_data": "IllusionMuseum-module-scss-module__jb6FTG__headings_sec_data",
  "image_sec": "IllusionMuseum-module-scss-module__jb6FTG__image_sec",
  "img_div": "IllusionMuseum-module-scss-module__jb6FTG__img_div",
  "img_sec": "IllusionMuseum-module-scss-module__jb6FTG__img_sec",
  "line": "IllusionMuseum-module-scss-module__jb6FTG__line",
  "linear_gradient_sec": "IllusionMuseum-module-scss-module__jb6FTG__linear_gradient_sec",
  "linear_gradient_sec_data": "IllusionMuseum-module-scss-module__jb6FTG__linear_gradient_sec_data",
  "museum_mystique_sec": "IllusionMuseum-module-scss-module__jb6FTG__museum_mystique_sec",
  "museum_page": "IllusionMuseum-module-scss-module__jb6FTG__museum_page",
  "ticket_btn": "IllusionMuseum-module-scss-module__jb6FTG__ticket_btn",
});
